import React, { FC, useState } from 'react';
import { AddNoteButton } from './Components/AddNoteButton';
import { NoteForm } from './Components/NoteForm';
import { NotesList } from './Components/NotesList';
import { DoctorNotesApi } from '../../../../Api/DoctorNotesApi';
import { InsuranceDoctorNoteDto } from '@apiModels/Insurance/InsuranceDoctorNoteDto.csharp';
import { useInsuranceLabels } from '../../../Utils/Context/labelsContext';

interface TreaterNotesProps {
  doctorId: string;
  notes: InsuranceDoctorNoteDto[];
}

export const TreaterNotes: FC<TreaterNotesProps> = (props) => {
  const api = new DoctorNotesApi();
  const [notes, setNotes] = useState<InsuranceDoctorNoteDto[]>(props.notes);
  const [isAddModalOpened, setIsAddModalOpened] = useState<boolean>(false);

  const {
    buttons
  } = useInsuranceLabels();
  
  const onClickAddNote = () => {
    setIsAddModalOpened(true);
  }

  const onEditNoteSubmit = async (noteId: string, noteText: string, cb: (status: 'success' | 'error') => void) => {
    try {
      await api.editNote({
        id: noteId,
        text: noteText
      })
      const updatedNotes = notes.map((note) => {
        if (note.id !== noteId) return note;
        else return {
          ...note,
          text: noteText,
        };
      })
      setNotes(updatedNotes);
      cb('success');
    } catch (error) {
      cb('error');
    }
  }

  const onAddNoteSubmit = async (noteText: string, cb: (status: 'success' | 'error') => void) => {
    try {
      const addedNote = await api.addNewNote(noteText, props.doctorId);
      setNotes([
        ...notes,
        addedNote
      ]);
      cb('success');
    } catch (error) {
      cb('error');
    }
  };

  const onDeleteNote = async (noteId: string, cb: (status: 'error' | 'success') => void) => {
    try {
      await api.deleteNote(noteId);
      const updatedNotes = notes.filter((note) => note.id !== noteId);
      setNotes(updatedNotes);
      cb('success');
    } catch (error) {
      cb('error');
    }
  };

  return (
    <div className="treaterNotes">
      <span className="treaterNotes__header">My notes:</span>
      {notes.length > 0 && (
        <NotesList notes={notes} onEditNoteSubmit={onEditNoteSubmit} onDeleteNote={onDeleteNote} />
      )}
      <AddNoteButton onClick={onClickAddNote} isModalOpened={isAddModalOpened} label={buttons.addNoteButtonLabel}/>
      {isAddModalOpened && (
        <NoteForm
          type="addNote"
          onSubmit={onAddNoteSubmit}
          onClose={() => setIsAddModalOpened(false)}
        />
      )}
    </div>
  );
};
